import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from '@shared/context/ToastProvider';
import { AuthProvider } from './context/AuthContext';
import { PerfilesProvider } from '@conductor/context/PerfilesContext';
import { SocketProvider } from '@conductor/hooks/useSocket';
import Router from './router/Router';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.scss';
import { FirebaseProvider } from './hooks/useFirebase';
import { LayoutAppProvider } from './context/LayoutAppContext';
import googleMapsConfig from '@shared/config/integrations/googleMaps.config';
import appGlobalConfig from '@shared/config/app/appGlobal.config';
import { ConfirmProvider } from '@shared/context/feedback/ConfirmProvider';
import { NotifyProvider } from './context/NotifyContext';
import TigerProvider from '@shared/context/mobile/TigerContext';
import ErrorBoundary from '@shared/componets/feedback/ErrorBoundary/ErrorBoundary';



function App() {

  return (
    <TigerProvider>
      <APIProvider apiKey={googleMapsConfig.API_KEY} libraries={googleMapsConfig.LIBRARIES_MAPS}>
        <BrowserRouter basename={appGlobalConfig.BASENAME}>
          <ToastProvider>
            <ConfirmProvider>
              <AuthProvider>
                <PerfilesProvider>
                  <FirebaseProvider>
                    <NotifyProvider>
                      <SocketProvider>
                        <LayoutAppProvider>
                            <ErrorBoundary>
                              <Router />
                            </ErrorBoundary>
                        </LayoutAppProvider>
                      </SocketProvider>
                    </NotifyProvider>
                  </FirebaseProvider>
                </PerfilesProvider>
              </AuthProvider>
            </ConfirmProvider>
          </ToastProvider>
        </BrowserRouter >
      </APIProvider >
    </TigerProvider>
  );
}

export default App;
